// This is the only place where we should be importing mixpanel-browser
// if functionality you need is missing, consider adding it here as a wrapped export
// import mixpanel from "mixpanel-browser";
import mixpanel from "mixpanel-browser";

function init() {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {
    autocapture: {
      pageview: "full-url",
      click: true,
      input: true,
      scroll: false,
      submit: true,
      capture_text_content: false,
    },
  });
}

function identify(userId: string) {
  mixpanel.identify(userId);
}

export default {
  init,
  identify,
};
